export const getLocation = ({router}) => router.location;